/**
 * Auth storage: when "Remember me" is unchecked we use sessionStorage
 * (session ends when tab closes); when checked we use localStorage.
 */
const AUTH_STORAGE_KEY = "authStorage";

export type AuthStorageType = "local" | "session";

export function getAuthStorage(): Storage {
  return typeof window === "undefined"
    ? ({} as Storage)
    : localStorage.getItem(AUTH_STORAGE_KEY) === "session"
      ? sessionStorage
      : localStorage;
}

export function setAuthStorage(rememberMe: boolean): void {
  if (typeof window === "undefined") return;
  localStorage.setItem(AUTH_STORAGE_KEY, rememberMe ? "local" : "session");
}

export function clearAuthStorage(): void {
  if (typeof window === "undefined") return;
  localStorage.removeItem(AUTH_STORAGE_KEY);
  localStorage.removeItem("currentUser");
  localStorage.removeItem("accessToken");
  localStorage.removeItem("refreshToken");
  sessionStorage.removeItem("currentUser");
  sessionStorage.removeItem("accessToken");
  sessionStorage.removeItem("refreshToken");
}
